<template>
  <span class="em-label" :class="[sizeClass]" :style="customStyle">
    <slot />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  bold?: boolean;
  bolder?: boolean;
  contrast?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'medium',
  bold: false,
  bolder: false,
  contrast: false,
});

const sizeClass = computed(() => `em-label--${props.size}`);

const customStyle = computed(() => {
  const style: Record<string, string> = {};
  if (props.color) style.color = props.color;
  if (props.bold) style.fontWeight = '600';
  if (props.bolder) style.fontWeight = '700';
  if (props.contrast) style.color = 'var(--ion-text-color-contrast)';
  return style;
});
</script>

<style scoped>
.em-label {
  display: inline;
  line-height: 1.4;
  color: inherit;
}

.em-label--small {
  font-size: 12px;
}

.em-label--medium {
  font-size: 14px;
}

.em-label--large {
  font-size: 24px;
}
</style>
